<template lang="html">
  <div class="purchase-wrapper" @resize="onResize($event)">
    <div class="images">
      <div class="carousel-wrapper">
        <!-- <div class="carousel-wrapper"> -->
        <carousel
          v-if="getMainImage2 !== null"
          :perPage="1"
          :loop="true"
          :navigationEnabled="false"
          :paginationEnabled="false"
          :paginationActiveColor="'#193965'"
          :paginationColor="'#D4D4D4'"
          :paginationSize="10"
          :autoplay="false"
          :navigateTo="this.carouselIndex"
          @page-change="showSlide2($event)"
          style="margin-bottom: 10px;"
        >
          <slide
            style="position:relative"
            @slide-click="showSlide(index)"
            v-for="(image, index) in productInfo.pro_image"
            :key="index"
          >
            <img class="img" :src="getImageSrc(index)" alt="carousel image" />
          </slide>
        </carousel>
        <carousel
          v-if="getMainImage2 !== null"
          :perPage="3"
          :loop="false"
          :navigationEnabled="false"
          :paginationEnabled="true"
          :paginationActiveColor="'#193965'"
          :paginationColor="'#D4D4D4'"
          :paginationSize="10"
          :autoplay="false"
          :navigateTo="this.carouselIndex"
        >
          <slide
            @slide-click="showSlide(index)"
            v-for="(image, index) in productInfo.pro_image"
            :key="index"
          >
            <img
              :class="{ big: index == carouselIndex }"
              class="noBig"
              :src="getImageSrc(index)"
              alt="carousel image"
            />
          </slide>
        </carousel>
        <div v-else class="defPIC">
          <img
            class="main-image default center"
            src="@/assets/images/defaultItemImage.png"
            alt="main carousel image"
          />
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!--     <vue-magnifier class="main-image default" v-if="getMainImage !== null" :src="getMainImage" :src-large="getMainImage"  id="magni" />
      <img v-else class="main-image default" src="@/assets/images/defaultItemImage.png" alt="main carousel image">
        <carousel v-if="getMainImage !== null"
          :perPage="3"
          :loop="true"
          :navigationEnabled="false"
          :paginationEnabled="true"
          :paginationActiveColor="'#E9786E'"
          :paginationColor="'#D4D4D4'"
          :paginationSize="10"
          :autoplay="false"
          :navigateTo="this.carouselIndex"
        >
          <slide @slide-click="showSlide(index)" v-for="(image, index) in productInfo.pro_image" :key="index">
            <img  :class="{big:(index==carouselIndex)}" class="noBig" :src="getImageSrc(index)" alt="carousel image">
          </slide>
        </carousel>
        <img v-else class="main-image default" src="@/assets/images/defaultItemImage.png" alt="main carousel image">
      </div>
    </div>  -->
    <div class="information-wrapper">
      <h1>{{ productInfo.pro_name }}</h1>
      <div class="user">{{ productInfo.usr_name }}</div>
      <!-- new -->
      <div class="breadcrumbs-wrapper">
        <div class="link" @click="changeCategory(productInfo.cat_id_parent)">
          {{ productInfo.cat_name_parent }}
        </div>

        <template v-if="productInfo.cat_id !== productInfo.cat_id_parent">
          <div style="margin:3px  10px 0px; width: fit-content">
            <img src="@/assets/newImges/icons/grt.svg" alt="" />
          </div>

          <div class="link" @click="changeCategory(productInfo.cat_id)">
            {{ productInfo.cat_name }}
          </div>
        </template>
      </div>
      <!-- end new  -->
      <div class="info pro_expiry">
        <span class="info-key">{{ $t("details.details.pro_expiry") }}:</span>
        <div class="info-value">
          {{
            $moment
              .utc(productInfo.pro_expiry)
              .local()
              .format("YYYY-MM-DD HH:mm")
          }}
        </div>
      </div>
      <div class="info opacity50">
        <span class="info-key">{{ $t("details.details.left_quantity") }}:</span>
        <span class="info-value">
          {{
            (parseInt(productInfo.quantity) - parseInt(productInfo.off_count))
              .toLocaleString("en")
              .split(",")
              .join(".")
          }}/{{
            parseInt(productInfo.quantity)
              .toLocaleString("en")
              .split(",")
              .join(".")
          }}
          <!-- {{ productInfo.mun_unit }} -->
          {{ showUnit(productInfo.mun_unit) }}
        </span>
      </div>
      <div class="info opacity50">
        <span class="info-key">{{ $t("details.details.startingPrice") }}:</span>
        <div class="info-value">
          {{
            productInfo.prices
              ? productInfo.prices[0].price
                  .toLocaleString("en")
                  .split(",")
                  .join(".")
              : ""
          }}
          {{ productInfo.cur_id }}
        </div>
      </div>

      <div
        class="info"
        v-if="
          seeExpiry(
            $moment
              .utc(productInfo.pro_expiry)
              .local()
              .format('YYYY-MM-DD HH:mm')
          )
        "
      >
        <div class="info-value iconsVal">
          <span @click="shareNative" class="share">
            <img
              style="cursor: pointer; "
              :src="require('@/assets/newImges/icons/link.svg')"
              alt="link"
            />
          </span>

          <ShareNetwork
            v-if="productInfo.pro_name"
            network="Facebook"
            :url="createUrl(productInfo.pro_id)"
            :title="productInfo.pro_name"
            :description="productInfo.pro_description"
            :quote="productInfo.pro_description"
            hashtags="eBerza"
          >
            <img
              style="cursor: pointer; "
              :src="require('@/assets/newImges/icons/facebook.svg')"
              alt="facebook logo"
            />
          </ShareNetwork>
          <ShareNetwork
            v-if="productInfo.pro_name"
            network="Twitter"
            :url="createUrl(productInfo.pro_id)"
            :title="productInfo.pro_name"
            :description="productInfo.pro_description"
            :quote="productInfo.pro_description"
            hashtags="eBerza"
          >
            <img
              style="cursor: pointer; "
              :src="require('@/assets/newImges/icons/XLogo.svg')"
              alt="twitter logo"
            />
          </ShareNetwork>
          <ShareNetwork
            v-if="productInfo.pro_name"
            network="email"
            :url="$t('txtemail') + createUrl(productInfo.pro_id) + '\n'"
            :title="productInfo.pro_name"
            :description="productInfo.pro_description + $t('txtemail2')"
            :quote="productInfo.pro_description"
            hashtags="eBerza"
          >
            <img
              class="imgShareIcon"
              :src="require('@/assets/newImges/icons/sharemail.svg')"
              alt="email share"
            />
          </ShareNetwork>
        </div>
      </div>
      <div class="red-info">
        <span class="info-key">{{ $t("details.details.current_price") }}:</span>
        <div class="info-value">
          {{
            productInfo.current_price
              ? productInfo.current_price
                  .toLocaleString()
                  .split(",")
                  .join(".")
              : ""
          }}
          {{ productInfo.cur_id }}
        </div>
      </div>
      <div class="main">
        <div
          class="description-price"
          v-for="(price, index) in productInfo.prices"
          :key="index"
        >
          <span class="price"
            >{{
              price.price
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            <span>{{ productInfo.cur_id }}</span></span
          >
          <span class="range"> / </span>
          <span
            v-if="
              price.min === price.max || (price.min === 0 && price.max === 1)
            "
            class="range"
            >{{
              price.max
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            {{ showUnit(productInfo.mun_unit) }}</span
          >

          <span v-else class="range"
            >{{
              price.min
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            -
            {{
              price.max
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            {{ showUnit(productInfo.mun_unit) }}</span
          >
        </div>
      </div>

      <!-- <table v-if="false">
        <tr>
          <th>
            <div class="header">
              {{ $t("details.details.quantity") }}
            </div>
          </th>
          <th>
            <div class="header">
              {{ $t("details.details.price") }}/{{ productInfo.cur_id }}
            </div>
          </th>
        </tr>
        <tr v-for="(price, index) in productInfo.prices" :key="index">
          <td>
            <span
              v-if="
                price.min === price.max || (price.min === 0 && price.max === 1)
              "
              class="info-key"
              >{{
                price.max
                  .toLocaleString("en")
                  .split(",")
                  .join(".")
              }}
              {{
                productInfo.mun_unit === "komad" ||
                productInfo.mun_unit === "komada"
                  ? $t("item.items")
                  : productInfo.mun_unit
              }}</span
            >
            <span v-else class="info-key"
              >{{
                price.min
                  .toLocaleString("en")
                  .split(",")
                  .join(".")
              }}
              -
              {{
                price.max
                  .toLocaleString("en")
                  .split(",")
                  .join(".")
              }}
              {{
                productInfo.mun_unit === "komad" ||
                productInfo.mun_unit === "komada"
                  ? $t("item.items")
                  : productInfo.mun_unit
              }}</span
            >
          </td>
          <td>
            <span class="info-key">{{ $t("details.details.unitPrice") }}:</span>
            <div class="info-value">
              {{
                price.price
                  .toLocaleString("en")
                  .split(",")
                  .join(".")
              }}
              {{ productInfo.cur_id }}
            </div>
          </td>
        </tr>
      </table> -->

      <div
        class="divBye"
        v-if="
          userIsLoged &&
            productInfo.my_product === 0 &&
            productInfo.has_offer !== 1
        "
      >
        <div class="info opacity50  mb-26p">
          <span class="info-key">{{ $t("details.details.available") }}:</span>
          <div class="info-value">
            {{ parseInt(productInfo.available) }}
            {{ showUnit(productInfo.mun_unit) }}
          </div>
        </div>
        <div class="info opacity50  mb-20p">
          <span class="info-key"
            >{{ $t("details.details.buyingQuantity") }}:</span
          >
          <input
            @input="checkQuantity"
            @change="checkQuantity"
            type="number"
            onkeydown="if(event.key==='.'){event.preventDefault();}"
            v-model="quantity"
            name="quantity"
            step="1"
            min="1"
            :max="parseInt(productInfo.available)"
            class="specialInput"
          />
        </div>
        <div class="info dropBR mb-20p">
          <!-- <span class="info-key"
            >{{ $t("details.details.purchaseTerms") }}:</span
          > -->
          <dropdown
            :defaultText="$t('details.details.purchaseTerms')"
            :selected="terms"
            :list="termsList"
            style="width: 100%;"
            @changeOption="terms = $event"
          />
        </div>
        <div v-if="terms && terms.value === 1" class="info mb-20p">
          <!-- <span class="info-key">{{ $t("details.details.price") }}:</span> -->
          <dropdown
            :defaultText="$t('details.details.price')"
            :selected="selectedPrice"
            :list="getPricesDropdown"
            style="width: 100%;"
            @changeOption="changeSelectedPrice"
          />
        </div>
        <div @click="buy" class="btn dark">
          {{ $t("main.buy") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "@/shared/eventBus.js";
import Dropdown from "@/components/dropdown.vue";
import { mapState } from "vuex";
import { api, baseURL } from "@/api";
// import vueMagnifier from './vue-magnifier'
// import { magni } from './magni'
export default {
  name: "itemPurchase",
  props: {
    productInfo: {
      type: Object
    }
  },
  components: {
    Dropdown
    // vueMagnifier
  },
  mounted() {
    // this.magnifi()
    // window.addEventListener('resize', this.onResize)
  },
  data() {
    return {
      styleObject: {
        backgroundRepeat: "no-repeat",
        top: 0,
        left: 0
        // backgroundSize: (img.width * zoom) + 'px ' + (img.height * zoom) + 'px'
      },
      mainData: ["left_quantity", "current_price"],
      carouselIndex: 0,
      quantity: null,
      x: null,
      y: null,
      terms: null,
      selectedPrice: null
    };
  },
  watch: {
    x: function(val) {
      this.styleObject.top = val;
      this.xx = val;
    },
    y: function(val) {
      this.styleObject.left = val;
    }
  },
  methods: {
    buy() {
      if (this.productInfo.is_locked === 1) {
        this.$toast.error(this.$t("details.purchase.locked"), {
          duration: 8000
        });
        return;
      }
      if (
        parseInt(this.quantity) === "" ||
        parseInt(this.quantity) < 1 ||
        parseInt(this.quantity) > this.productInfo.available
      ) {
        this.$toast.error(this.$t("details.purchase.purchaseError"), {
          duration: 8000
        });
        return;
      }
      if (!this.quantity) {
        this.$toast.error(this.$t("details.purchase.missingQuantityError"), {
          duration: 8000
        });
        return;
      }
      if (!this.terms) {
        this.$toast.error(this.$t("details.purchase.termsError"), {
          duration: 8000
        });
        return;
      }
      if (this.terms && this.terms.value === 1 && this.selectedPrice === null) {
        this.$toast.error(this.$t("details.purchase.priceError"), {
          duration: 8000
        });
        return;
      }
      console.log(this.quantity);
      let params = {
        off_quantity: this.quantity,
        pro_id: this.productInfo.pro_id
      };
      if (this.selectedPrice === null) {
        params.prc_id = this.getPricesDropdown[0].value;
      } else {
        params.prc_id = this.selectedPrice.value;
      }
      let modalData = {
        title: this.$t("details.purchase.placeOrder"),
        ok: () => {
          this.setOffer(params);
        }
      };
      let modalParams = {
        modalData: modalData,
        component: "confirmModal"
      };
      eventBus.$emit("openModal", modalParams);
    },
    createUrl(id) {
      return (
        document.location.origin + "/" + this.$i18n.locale + "/details/" + id
      );
    },
    setOffer(params) {
      eventBus.$emit("showLoader", true);
      api
        .setOffer(params)
        .then(res => {
          console.log(res);
          this.$toast.success(this.$t("details.purchase.purchaseSuccess"), {
            duration: 8000
          });
        })
        .catch(e => {
          console.log(e);
          this.$toast.error(this.$t("details.purchase.purchaseError"), {
            duration: 8000
          });
        })
        .finally(() => {
          eventBus.$emit("showLoader", false);
          this.$emit("refresh");
        });
    },
    checkQuantity(e) {
      if (parseInt(e.target.value) > parseInt(this.productInfo.available)) {
        this.$toast.error(
          this.$t("details.purchase.quantityLimit") +
            this.productInfo.available,
          {
            duration: 8000
          }
        );
        this.quantity = parseInt(this.productInfo.available);
      } else if (parseInt(e.target.value) < 1) {
        this.quantity = 1;
      } else if (e.target.value === "") {
        // this.quantity = 1
      }
    },
    changeTerms(option) {
      this.terms = option;
    },
    changeSelectedPrice(option) {
      this.selectedPrice = option;
    },
    getPrices(prices) {
      let str = "";
      for (var i = 0; i < prices.length; i++) {
        const price = prices[i];
        str +=
          price.min +
          " - " +
          price.max +
          " kom - " +
          price.price
            .toLocaleString()
            .split(",")
            .join(".") +
          "<br>";
      }
      return str;
    },
    showUnit(munUnit) {
      if (munUnit === "komad" || munUnit === "komada") {
        return this.$t("item.items");
      } else if (munUnit === "paket" || munUnit === "paketa") {
        return this.$t("item.package");
      }
      return munUnit;
    },
    getImageSrc(index) {
      return baseURL + this.productInfo.pro_image[index];
    },
    showSlide(index) {
      this.carouselIndex = index;
    },
    showSlide1(e) {
      console.log(e);
      if (
        e === "forward" &&
        this.carouselIndex < this.productInfo.pro_image.length - 1
      ) {
        this.carouselIndex++;
      } else if (
        e === "forward" &&
        this.carouselIndex >= this.productInfo.pro_image.length - 1
      ) {
        this.carouselIndex = 0;
      } else if (e === "backward" && this.carouselIndex >= 1) {
        this.carouselIndex--;
      } else if (e === "backward" && this.carouselIndex >= 0) {
        this.carouselIndex = this.productInfo.pro_image.length - 1;
      }
    },
    showSlide2(e) {
      this.carouselIndex = e;
    },
    updateXY(event) {
      this.x = event.offsetX;
      this.y = event.offsetY;
      this.xx = event.offsetX;
      this.yy = event.offsetY;
    },
    mouseOut(event) {
      this.x = 0;
      this.y = null;
    },
    onResize(e) {
      console.log(e);
    },
    seeExpiry(expiry) {
      // 2022-01-30 09:19   - this form parameter get
      // console.log(expiry.substr(0, 4), expiry.substr(5, 2), expiry.substr(8, 2), expiry.substr(11, 2), expiry.substr(14, 2))
      let date = new Date(
        expiry.substr(0, 4),
        expiry.substr(5, 2) - 1,
        expiry.substr(8, 2),
        expiry.substr(11, 2),
        expiry.substr(14, 2)
      );
      console.log(date);
      console.log(new Date());
      console.log(date - new Date());
      return date - new Date() > 1;
    },
    changeCategory(category) {
      console.log("asd");
      const query = {
        category: category
      };
      this.$router.push({
        name: "Result",
        params: this.$route.params,
        query: query
      });
    },
    shareNative() {
      navigator.clipboard.writeText(window.location.href);
      this.$toast.success(this.$t("news.copyLink"), {
        duration: 5000
      });
    }
  },
  computed: {
    xx: {
      get() {
        return this.styleObject.top;
      },
      set(x) {
        console.log();
        this.styleObject.top = x;
      }
    },
    yy: {
      get() {
        return this.styleObject.left;
      },
      set(y) {
        this.styleObject.left = y;
      }
    },
    ...mapState(["userIsLoged"]),
    getMainImage() {
      return this.productInfo.pro_image
        ? this.getImageSrc(this.carouselIndex)
        : null;
    },
    getPricesDropdown() {
      if (this.productInfo.prices) {
        let prices = [];
        for (var i = 0; i < this.productInfo.prices.length; i++) {
          let obj = {
            value: this.productInfo.prices[i].prc_id,
            label:
              this.productInfo.prices[i].price
                .toLocaleString("en")
                .split(",")
                .join(".") +
              " " +
              this.productInfo.cur_id
          };
          prices.push(obj);
        }
        return prices;
      }
      return [];
    },
    getMainImage2() {
      let res =
        this.productInfo.pro_image && this.productInfo.pro_image.length !== 0
          ? this.getImageSrc(this.carouselIndex)
          : null;
      console.log(res);
      return res;
    },
    termsList() {
      return [
        {
          label: this.$t("dropdown.condition1"),
          value: 1
        },
        {
          label: this.$t("dropdown.condition2"),
          value: 2
        }
      ];
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
span > .preview,
.vue-magnifier-container {
  box-sizing: border-box;
  min-width: 98% !important;
  margin: 0px 0 0 0 !important;
}
span > .preview {
  background: red;
  margin: 0px 0 0 0 !important;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.purchase-wrapper {
  display: flex;
  flex-direction: row;
  position: relative;
  flex-wrap: wrap;
  margin-bottom: 85px;
  .VueCarousel {
    border-radius: 12px;
    overflow: hidden;
  }
  .images {
    width: 50%;
    //width: 610px;
    text-align: right;
    max-width: 600px;
    box-sizing: border-box;
    // min-width: 400px;
    margin-bottom: 60px;

    .main-image {
      z-index: 1;
      width: 100%;
    }
    .main-image.default {
      width: 252px;
    }
    .defPIC {
      /* default */
      width: 100%;
      display: flex;
      box-sizing: border-box;
      justify-content: center;
      align-items: center;
      .main-image.default.center {
        width: 60%;
      }
    }
    .carousel-wrapper {
      .VueCarousel-inner {
        align-items: center;
        // justify-content: center
      }
      .VueCarousel-slide {
        display: flex !important;
        justify-content: center;
        align-items: center;
      }
      .vue-magnifier,
      img {
        display: block;
        box-sizing: border-box;
        width: 98%;
        cursor: pointer;
      }
      .vue-magnifier,
      .img {
        display: block;
        box-sizing: border-box;
        //  max-width: 98%;
        max-height: 600px;
        aspect-ratio: 1 / 1;
        width: 100%;
        height: inherit !important;
        object-fit: cover;
      }
    }
  }
  .noBig {
    box-sizing: border-box;
    border: solid 2px rgba(233, 120, 110, 0);
    border-radius: 12px;
    aspect-ratio: 1 / 1;
  }
  .big {
    box-sizing: border-box;
    border: solid 2px $blue-400;
  }

  .information-wrapper {
    max-width: 60%;
    padding-left: 50px;
    width: fit-content;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    color: $text-color;
    box-sizing: border-box;

    .btn {
      width: 135px;
      height: 52px;
      border-radius: 12px;
      margin-top: 29px;
    }
    table {
      width: 100%;

      th {
        font-weight: 800;
        font-size: 13px;
        line-height: 21px;
        letter-spacing: 0.06em;
        color: rgba(160, 160, 160, 0.9);
        text-transform: uppercase;
        margin-bottom: 10px;
      }
      .info-key {
        font-weight: normal;
        font-size: 13px;
        line-height: 21px;
        color: #787878;
        margin-right: 10px;
        white-space: nowrap;
      }
      .info-value {
        font-weight: 800;
        font-size: 13px;
        line-height: 18px;
        letter-spacing: 0.02em;
        color: $text-color;
      }
    }
    .prices-wrapper {
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;

      .quantity,
      .prices {
        display: flex;
        flex-direction: column;

        .header {
          font-weight: 800;
          font-size: 13px;
          line-height: 21px;
          letter-spacing: 0.06em;
          color: rgba(160, 160, 160, 0.9);
          text-transform: uppercase;
          margin-bottom: 10px;
        }
        .info {
          flex-wrap: nowrap;
          white-space: nowrap;
        }
      }
      .quantity {
        margin-right: 15px;
      }
    }
    h1 {
      font-weight: 500;
      font-style: Medium;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;

      max-width: 100%;
      text-overflow: ellipsis;
      // word-break: break-all;
      overflow: hidden;
      color: $blue-1000;
      margin: 0;
      margin-bottom: 10px;
    }
    .user {
      font-weight: 500;
      font-style: Medium;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;
      color: $gray-blue-1300;
      margin-bottom: 13px;
    }

    h3 {
      font-weight: bold;
      font-size: 16px;
      line-height: 26px;
      margin-top: 15px;
    }
    .info {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;

      font-weight: 400;
      font-style: Regular;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: 0%;
      color: $blue-1000;

      margin-bottom: 12px;

      .info-key {
        margin-right: 10px;
        white-space: nowrap;
      }

      .iconsVal {
        display: flex;
        justify-content: center;
        align-items: center;

        margin-top: 29px;
        margin-bottom: 29px;

        img {
          margin-right: 15px;
        }
      }
    }
    .opacity50 {
      opacity: 0.5;
    }
    .pro_expiry {
      font-weight: 400;
      font-style: Regular;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: 0%;
      color: $blue-1000;
      opacity: 100;
    }
    .red-info {
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-weight: 400;
      font-style: Regular;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: 0%;

      color: $light-blue-600;
      margin-bottom: 29px;

      .info-key {
        margin-right: 10px;
        white-space: nowrap;
      }
      .info-value {
        text-align: center;
      }
    }
    .section-end {
      margin-top: 10px;
      margin-bottom: 20px;
      height: 1px;
      width: 100%;
      background-color: #eaeaea;
    }
  }
}
// new
.breadcrumbs-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  margin-bottom: 30px;
  padding-left: 0px;
  flex-wrap: wrap;
  font-weight: 500;
  font-style: Medium;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-bottom: 26px;
  .link {
    cursor: pointer;
    color: $blue-1000;
  }
}
.main {
  min-height: 75px;

  color: $blue-1000;
  margin-bottom: 29px;
  .description-price {
    margin-bottom: 15px;
  }
  .price {
    font-weight: 500;
    font-style: Medium;
    font-size: 30px;
    line-height: 100%;
  }
  .range {
    font-weight: 400;
    font-style: Regular;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;
  }
}

.magnifiDiv {
  width: 97px;
  height: 97px;
  border-radius: 50%;
  border: 3px solid rgb(161, 26, 26);
  box-sizing: border-box;
  background: inherit;
  position: absolute;
}
.dropBR {
  display: flex;
  flex-direction: row;
}
.mb-20p {
  margin-bottom: 20px !important;
}
.mb-26p {
  margin-bottom: 26px !important;
}
@media only screen and (max-width: 1000px) {
  .purchase-wrapper {
    flex-direction: column;

    .images {
      width: 100%;
      max-width: 500px;
      margin: 0 auto;
      margin-bottom: 60px;
      padding-right: 0px;
    }
    .information-wrapper {
      width: 100% !important;
      padding-left: 0px !important;
    }
  }
}
@media only screen and (max-width: 767px) {
  .purchase-wrapper {
    margin-bottom: 0px;
    .information-wrapper {
      width: 100% !important;
      max-width: 100%;
      padding-left: 0px !important;
    }
  }
  .divBye {
    max-width: 100%;
  }
  // .info.dropBR{
  //   display: flex;
  //   flex-direction: column !important;
  //   justify-content: center;
  //   align-items: center;
  //   text-align: left;
  //  }
  .info {
    .info-key {
      font-size: 15px;
    }
    .iconsVal {
      display: flex;
      justify-content: center;
      align-items: center;

      margin-top: 19px;
      margin-bottom: 19px !important;

      img {
        margin-right: 10px;
        width: 40px;
      }
    }
  }
}
.specialInput {
  //border-color:red;
  // max-width: 20%;
  width: 60px;
  height: 35px;
  border-radius: 6px;
  border: 1px solid $blue-400;
  outline: none;
}
.main {
  min-height: 75px;
  color: $blue-1000;
  .description-price {
    margin-bottom: 10px;
  }
  .price {
    font-size: 18px;
    line-height: 100%;
  }
  .range {
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0%;
  }
}
</style>

<style lang="scss">
@media only screen and (min-width: 1280px) {
  .images {
    width: 600px;
    box-sizing: border-box;
    // min-width: 400px;
    margin-bottom: 60px;

    .main-image {
      width: 100%;
    }

    .VueCarousel {
      width: 100%;
      box-sizing: border-box;
    }
  }
}
@media only screen and (min-width: 1000px) {
  .images {
    width: 550px;
    box-sizing: border-box;
    // min-width: 400px;
    margin-bottom: 60px;

    .main-image {
      width: 100%;
    }
    .VueCarousel {
      width: 100%;
      box-sizing: border-box;
    }
  }
}
@media only screen and (max-width: 1000px) {
  .images {
    width: 880px;
    box-sizing: border-box;
    // min-width: 400px;
    margin-bottom: 60px;

    .main-image {
      width: 100%;
    }
    .VueCarousel {
      width: 100%;
      box-sizing: border-box;
    }
  }
}
@media only screen and (max-width: 880px) {
  .images {
    width: 40%;
    width: 480px;
    box-sizing: border-box;
    // min-width: 400px;
    margin-bottom: 60px;

    .main-image {
      width: 100%;
    }
    .VueCarousel {
      width: 100%;
      box-sizing: border-box;
    }
  }
}
@media only screen and (max-width: 480px) {
  .images {
    width: 40%;
    width: 320px;
    box-sizing: border-box;
    // min-width: 400px;
    margin-bottom: 60px;

    .main-image {
      width: 100%;
    }
    .VueCarousel {
      width: 100%;
      box-sizing: border-box;
    }
  }
}
@media only screen and (max-width: 320px) {
  .images {
    width: 40%;
    width: 250px;
    box-sizing: border-box;
    // min-width: 400px;
    margin-bottom: 60px;

    .main-image {
      width: 100%;
    }
    .VueCarousel {
      width: 100%;
      box-sizing: border-box;
    }
  }
}
@media only screen and (max-width: 250px) {
  .images {
    width: 40%;
    width: 120px;
    box-sizing: border-box;
    // min-width: 400px;
    margin-bottom: 60px;

    .main-image {
      width: 100%;
    }
    .VueCarousel {
      width: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
<style lang="scss">
.VueCarousel {
  background: rgb(255, 255, 255);
  z-index: 0;
}
.VueCarousel-dot {
  outline: none !important;
}
.VueCarousel-inner {
  align-items: center;
  //justify-content: space-between;
}
.VueCarousel-pagination {
  position: absolute;
  bottom: -30px;
  height: 30px;

  .VueCarousel-dot-container {
    height: 30px;
    margin-top: 0px !important;

    button {
      margin-top: 0px !important;
    }
  }
}
</style>
<style lang="scss">
.VueCarousel {
  background: rgb(255, 255, 255);
}
.VueCarousel-dot {
  outline: none !important;
}
.VueCarousel-inner {
  align-items: center;
  justify-content: initial;
}
.VueCarousel-pagination {
  position: absolute;
  bottom: -30px;
  height: 30px;

  .VueCarousel-dot-container {
    height: 30px;
    margin-top: 0px !important;

    button {
      margin-top: 0px !important;
    }
  }
}

.details-slider-wrapper {
  background: #ffffff;
}
</style>
